import controller from './bill-info-edit.controller';

export default {
  bindings: {
    invoice: '<'
  },
  controller,
  template: require('./bill-info-edit.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info-edit/bill-info-edit.component.ts